import { gql } from '@apollo/client';

import { FileUploadFragment } from './FileUpload.graphql';

export const SyncedPayrollMonthExpenseFragment = gql`
  fragment SyncedPayrollMonthExpense on SyncedPayrollMonthExpense {
    id
    originalSyncDate
    period {
      startMonthYear {
        month
        year
      }
      endMonthYear {
        month
        year
      }
    }
    fileUpload {
      ...FileUpload
    }
  }
  ${FileUploadFragment}
`;
